"use client";

import { Analytics as AnalyticsClient } from "@vercel/analytics/react";
import { Element } from "react-scroll";
import CountUpClient from "react-countup";

import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { useState } from "react";

export const Analytics = (p) => {
  return <AnalyticsClient {...p} />;
};

export const ScrollElement = (p) => {
  return <Element {...p} />;
};

export const CountUp = (p) => {
  return <CountUpClient {...p} />;
};

export const QProvider = ({ children }) => {
  const [qc] = useState(() => new QueryClient());
  return <QueryClientProvider client={qc}>{children}</QueryClientProvider>;
};
